module.exports = __webpack_public_path__ + "static/media/lateral-flexion-up-2.16b6bb96.png";